module.exports = __webpack_public_path__ + "img/style-empty-placeholder.9d3ffc24.png";